import Phaser from 'phaser';

const BG_OUTER = 0x0a0f1f;
const BG_INNER = 0x1e293b;
const BOLT_CYAN = 0x22d3ee;
const BOLT_LIGHT = 0xa5f3fc;
const GLOW = 0x67e8f9;
const STROKE = 0xffffff;

export function drawBolt(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  g.fillStyle(GLOW, 0.3);
  g.fillCircle(0, 0, r * 0.82);

  const pts = boltPoints(r);

  g.fillStyle(BOLT_CYAN, 1);
  g.beginPath();
  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
  g.closePath();
  g.fillPath();

  const innerPts = boltPoints(r * 0.7);
  g.fillStyle(BOLT_LIGHT, 0.9);
  g.beginPath();
  g.moveTo(innerPts[0].x, innerPts[0].y);
  for (let i = 1; i < innerPts.length; i++) g.lineTo(innerPts[i].x, innerPts[i].y);
  g.closePath();
  g.fillPath();

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.8)), 0x0a0f1f, 1);
  g.beginPath();
  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
  g.closePath();
  g.strokePath();
}

function boltPoints(r: number): { x: number; y: number }[] {
  return [
    { x: -r * 0.12, y: -r * 0.78 },
    { x: r * 0.28, y: -r * 0.78 },
    { x: -r * 0.02, y: -r * 0.1 },
    { x: r * 0.22, y: -r * 0.1 },
    { x: -r * 0.28, y: r * 0.78 },
    { x: -r * 0.05, y: r * 0.15 },
    { x: -r * 0.34, y: r * 0.15 },
  ];
}
